import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { getAccessInfo } from 'src/selectors/user'
import { UserPermission } from 'src/constants/user'

const useCheckPermissions = () => {
  const accessInfo = useSelector(getAccessInfo)

  const hasPermission = useCallback(
    (permission: UserPermission): boolean => {
      return !!accessInfo?.permissions?.includes(permission)
    },
    [accessInfo],
  )

  const hasSomePermission = useCallback(
    (permissions: UserPermission[]): boolean => {
      return permissions.some((permission) => accessInfo?.permissions?.includes(permission))
    },
    [accessInfo],
  )

  const hasEveryPermission = useCallback(
    (permissions: UserPermission[]): boolean => {
      return permissions.every((permission) => accessInfo?.permissions?.includes(permission))
    },
    [accessInfo],
  )

  return {
    hasPermission,
    hasSomePermission,
    hasEveryPermission,
  }
}

export default useCheckPermissions
